import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import moment from 'moment';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../page-accordion';
import PromoMessage from '../promo-message';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        let state = {
            open_chapters: [],
        };

        if (props.route) {
            state.open_chapters.push(props.route);
        }

        this.state = state;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.route != this.props.route) {
            if (nextProps.route != '') {
                if (nextProps.route === 'main') {
                    this.setState({open_chapters: []});
                    accScroll('main', 500);
                } else {
                    let opened = toggleSection(this.state.open_chapters, nextProps.route);
                    const state = this.state;
                    state.open_chapters = opened;
                    this.setState(state);
                }
            }
            return true;
        }
        if (nextState != this.state) {
            return true;
        }
        if (nextProps.report != this.props.report) {
            return true;
        }
        if (nextProps.inputs != this.props.inputs) {
            return true;
        }
        return false;
    }

    render({ inputs }) {
        return (
            <cosmic-profile-report>
                <p className='has-text-left-print has-text-center'>
                    <b>Name:</b>
                    &nbsp;{inputs.person_1_name.first}
                    &nbsp;{inputs.person_1_name.last}
                    <br />
                    <b>Birthdate:</b> {this.renderBirthDate()}
                </p>
                {this.renderSections()}
                <PromoMessage placement='in-product' tags='cospro,nextsteps' />
            </cosmic-profile-report>
        );
    }

    renderBirthDate = () => {
        if (this.props.inputs.person_1_birth_time && this.props.inputs.person_1_birth_time != 'unknown') {
            const birth_datetime = moment(
                this.props.inputs.person_1_birth_date + ' ' + this.props.inputs.person_1_birth_time,
                'YYYY-MM-DD HH:mm:ss'
            );
            return birth_datetime.format('MMMM D, YYYY') + ' at ' + birth_datetime.format('h:mm A');
        }
        return moment(this.props.inputs.person_1_birth_date, 'YYYY-MM-DD').format('MMMM D, YYYY');
    }

    renderSections = () => {
        if (this.props.report.restrictions.indexOf('has_birth_time') !== -1) {
            return [
                this.renderOutput(0, 'chapter-1'),
                this.renderOutput(1, 'chapter-2'),
                this.renderOutput(2, 'chapter-3'),
                this.renderOutput(3, 'chapter-4'),
                this.renderOutput(4, 'chapter-5'),
                this.renderOutput(5, 'chapter-6'),
                this.renderOutput(6, 'chapter-7'),
            ];
        }
        return [
            this.renderOutput(0, 1),
            this.renderBlank('Your Moon Sign', 2),
            this.renderBlank('Your Rising Sign', 3),
            this.renderOutput(1, 4),
            this.renderOutput(2, 5),
            this.renderOutput(3, 6),
            this.renderOutput(4, 7),
        ];
    }

    renderBlank = (header, chapterNumber) => {
        let image_url = 'https://gfx.tarot.com/images/site/tarot/cosmic-profile/mobile/glyphs_question.svg';
        const id = `chapter-${chapterNumber}`;
        const isOpen = sectionIsOpen(this.state.open_chapters, id);
        return (
            <div
                className={`report-item ${isOpen ? 'is-open' : 'is-closed'}`}
                id={id}
            >
                <a href={`#${id}`} onClick={(e) => this.goTo(e, id)} className='report-item-tab'>
                    <row>
                        <column className='is-1 is-2-mobile'>
                            <img src={image_url} />
                        </column>
                        <column className='is-11 is-10-mobile'>
                            <h4 className='title'>Unknown</h4>
                            <h5 className='title'>{header}</h5>
                        </column>
                    </row>
                </a>
                <div className='report-item-content'>
                    <p>
                        Your sign is determined by your exact birth time and location, because the planetary placements
                        that govern Astrology are in constant motion. Depending upon the specifics of your unique
                        situation, the difference of even an hour can affect the accuracy of your Cosmic Profile!
                        Astrologers use the exact placement of these key indicators as a basis for the most detailed and
                        specific interpretations. If you don't have your exact birth time or exact birth location right
                        now, go ahead and run your Cosmic Profile without it -- you will still learn something
                        meaningful about your cosmic identity. Want to personalize your profile by updating your birth
                        time and location? <a href='/readings-reports/astrology-reports/cosmic-profile'>Run another
                        FREE profile NOW</a>!
                    </p>
                    <div className='has-text-right'>
                        <a href='#' onClick={(e) => this.goTo(e, 'main')} className='is-hidden-print'>Back to Top</a>
                    </div>
                </div>
            </div>
        );
    }

    renderOutput = (sectionNumber, chapterNumber) => {
        const section = this.props.report.display.sections[sectionNumber];
        let title = section.block[0].content[0].title;
        const id = chapterNumber;
        const isOpen = sectionIsOpen(this.state.open_chapters, id);
        return (
            <div
                className={`report-item ${isOpen ? 'is-open' : 'is-closed'}`}
                id={id}
            >
                <a href={`#${id}`} onClick={(e) => this.goTo(e, id)} className='report-item-tab'>
                    <row>
                        <column className='is-1 is-2-mobile'>
                            <img src={section.block[0].content[0].image} />
                        </column>
                        <column className='is-11 is-10-mobile'>
                            <h4 className='title'>{title}</h4>
                            <h5 className='title'>{section.title}</h5>
                        </column>
                    </row>
                </a>
                <div className='report-item-content'>
                    {this.renderAttributes(section.block[0].content[0].attributes)}
                    {this.renderMoreAbout(title, section.section_code)}
                    {this.renderBody(section.block[0].content[0].body, title)}
                    {this.renderPromoMessage(section.section_code)}
                    <div className='has-text-right'>
                        <a href='#' onClick={(e) => this.goTo(e, 'main')} className='is-hidden-print'>Back to Top</a>
                    </div>
                </div>
            </div>
        );
    }

    renderMoreAbout = (title, code) => {
        if (['sun_sign', 'moon_sign', 'rising_sign'].indexOf(code) !== -1) {
            return this.renderMoreAboutZodiac(title, code);
        } else if (code == 'chinese_sign') {
            return this.renderMoreAboutChinese(title);
        } else if (code == 'tarot_birth_card') {
            return this.renderMoreAboutTarot(title);
        } else if (code == 'life_path_number') {
            return this.renderMoreAboutNumber();
        } else if (code == 'celtic_tree_sign') {
            return this.renderMoreAboutCeltic(title);
        }
        return null;
    }

    renderMoreAboutZodiac = (title, code) => {
        let zodiac_url = `/astrology/zodiac/${title.toLowerCase()}`;
        let horoscope_text = 'Your Personal Moon Report';
        let horoscope_url = 'https://product.tarot.com/product/?id=85400';
        if (code == 'sun_sign' || code == 'rising_sign') {
            horoscope_text = `${title} Daily Horoscope`;
            horoscope_url = `/daily-horoscope/${title.toLowerCase()}`;
        }
        return (
            <p className='is-hidden-print'>
                <a href={zodiac_url}>More About {title}</a><br />
                <a href={horoscope_url}>{horoscope_text}</a><br />
            </p>
        );
    }

    renderMoreAboutTarot = (tarot) => {
        return (
            <p className='is-hidden-print'>
                <a href={`/tarot/cards/${tarot.toLowerCase().replace(/ /g, '-')}`}>More About {tarot}</a>
            </p>
        );
    }

    renderMoreAboutChinese = (sign) => {
        sign = sign.toString();
        let chinese_sign_url = '/astrology/chinese-zodiac/'+ sign.toLowerCase();
        return (
            <p className='is-hidden-print'>
                <a href={chinese_sign_url}>More About The {sign.toString()}</a><br />
                <a href='https://product.tarot.com/product/input/?id=85800'> Get Your Complete Chinese Profile</a>
            </p>
        );
    }

    renderMoreAboutCeltic = (tree) => {
        return (
            <p className='is-hidden-print'>
                <a href='/astrology/celtic-signs'>More About {tree}</a><br />
                <a href='https://product.tarot.com/product/input/?id=85100&feature=cos-pro-celtic-upsell'>
                Get Your Complete Celtic Astrology Report</a>
            </p>
        );
    }

    renderMoreAboutNumber = () => {
        return (
            <p className='is-hidden-print'>
                <a
                    href='/numerology'
                    target='_blank'
                    rel='noopener'
                    onClick={() => { this.props.trackEvent([
                        'Cosmic Profile Report',
                        'LI Click',
                        'Learn More About Numerology',
                    ]); }}
                >
                    Learn More About Numerology
                </a>
            </p>
        );
    }

    renderBody = (body, title) => {
        if (body !== title && body !== `${title} Tree`) {
            return (
                <p>{body}</p>
            );
        }
        return null;
    }

    renderPromoMessage = (code) => {
        if (['sun_sign', 'moon_sign', 'rising_sign'].indexOf(code) !== -1) {
            return (<p><PromoMessage placement='text' tags='general' /></p>);
        } else if (code == 'chinese_sign') {
            return (<p><PromoMessage placement='text' tags='hexagram' /></p>);
        } else if (code == 'life_path_number') {
            return (<p><PromoMessage placement='text' tags='number' /></p>);
        } else if (code == 'tarot_birth_card') {
            return (<p><PromoMessage placement='text' tags='tarot' /></p>);
        }
        return null;
    }

    renderAttributes = (attributes) => {
        return(
            <p>
                {attributes.map(attribute => {
                    if (attribute[0] == 'Motto' || attribute[0] == 'Mantra') {
                        return [
                            <b>{attribute[0]}&nbsp;&nbsp;&nbsp;</b>,
                            <span>"{attribute[1]}"</span>,
                            <br />,
                        ];
                    }

                    return [
                        <b>{attribute[0]}&nbsp;&nbsp;&nbsp;</b>,
                        attribute[1],
                        <br />,
                    ];
                })}
            </p>
        );
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;
        if (chapter === 'main') {
            state.open_chapters = [];
            clickResult[2] = false;
        } else {
            state.open_chapters = clickResult[0];
            this.setState(state);
        }
        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }
        if (clickResult[2] == true) {
            accScroll(chapter, 400);
        }
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    report: state.report && state.report.product,
    inputs: state.report && state.report.product && state.report.product.inputs,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
